import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  class: "userSetUpBox"
};
const _hoisted_3 = {
  class: "dropdown-box"
};
const _hoisted_4 = {
  class: "user-name"
};
const _hoisted_5 = {
  class: "main-box"
};
import menuBox from "@/components/menu-box";
import exitPassword from "./components/exit-password";
import PersonalInformation from "./components/PersonalInformation";
import { CaretBottom } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router/dist/vue-router";
import { useStore } from "vuex";
import { computed, getCurrentInstance, ref } from "vue";
import { ElNotification } from "element-plus";
const __default__ = {
  name: "mainIndex"
};
export default /*@__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const {
        proxy
      } = getCurrentInstance(),
      that = proxy;
    const router = useRouter(),
      route = useRoute(),
      store = useStore();
    const nickName = computed(() => {
      let nickName = "用户名";
      if (store.state.user.nickName) nickName = store.state.user.nickName;
      if (store.state.user.operator) nickName = store.state.user.operator;
      return nickName;
    });
    const src = computed(() => {
      let src = "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80";
      if (store.state.user.avatar) src = store.state.avatar;
      return src;
    });
    const fit = "cover";
    const exit_password_show = ref(false); // 修改密码
    const PersonalInformationShow = ref(false);
    const command_change = e => {
      console.log(e);
      switch (e) {
        case "Personal_Information":
          personal_Information();
          break;
        case "exit_password":
          exit_password();
          break;
        case "login_out":
          login_out();
          break;
        default:
          break;
      }
    };
    const personal_Information = () => {
      PersonalInformationShow.value = true;
    };

    // 修改密码
    const exit_password = () => {
      exit_password_show.value = true;
    };
    // 退出
    const login_out = () => {
      that.$post('auth/logout').then(res => {
        if (!res) return false;
        store.commit("SET_TOKEN", "");
        ElNotification.success({
          title: "账号退出成功",
          customClass: "ApiMessage"
        });
        router.replace("/");
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "layout-container-demo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, null, {
          default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "logo"
          }, " 御锦产品培训平台 ", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, {
            onCommand: command_change,
            trigger: "click"
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: "Personal_Information"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 个人信息 ")])),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "exit_password"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 修改密码 ")])),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "login_out"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 退出 ")])),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(nickName.value), 1), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_unref(CaretBottom))]),
              _: 1
            })])]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            width: "200px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_createVNode(_unref(menuBox))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_unref(exitPassword), {
        modelValue: exit_password_show.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => exit_password_show.value = $event)
      }, null, 8, ["modelValue"]), _createVNode(_unref(PersonalInformation), {
        modelValue: PersonalInformationShow.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => PersonalInformationShow.value = $event)
      }, null, 8, ["modelValue"])], 64);
    };
  }
});